import Season from "../sports/common/season";
import mapDate from "./date-mapper";
import SportService from "../services/sport-service";

const mapSeason = (jsonObj) => {
    const season = Object.assign(new Season(), jsonObj);
    season.startDate = mapDate(season.startDate);
    season.endDate = mapDate(season.endDate);
    season.ruleSetId =
        season.ruleSetId ||
        SportService.getDefaultRuleSetId(season.sport.sportId);

    return season;
};

export default mapSeason;
